export const servingOptions = [
  {
    id: '8srv',
    servings: 8,
    label: '8 Feedings',
    price: 9.99,
    originalPrice: 13.99,
    ounces: 2.5,
    makes: 'Makes up to 8 feedings',
    shipping: 'Ships in 1–2 business days',
  },
  {
    id: '16srv',
    servings: 16,
    label: '16 Feedings',
    price: 19.99,
    originalPrice: 24.99,
    ounces: 5,
    badge: 'BEST SELLER',
    makes: 'Makes up to 16 feedings',
    shipping: 'Ships in 1–2 business days',
  },
  {
    id: '32srv',
    servings: 32,
    label: '32 Feedings',
    price: 34.99,
    originalPrice: 49.99,
    badge: 'BEST VALUE',
    ounces: 10,
    makes: 'Makes up to 32 feedings',
    shipping: 'Ships in 1–2 business days',
  },
];

export const product = {
  id: 'nectar-pouch',
  name: 'Front Porch Nectar — Dry Nectar Mix',
  image: 'https://public.readdy.ai/ai/img_res/edited_07538445cd9d8b114124da3434bc9269_ceeec3de.jpg',
  description: 'A dry nectar mix — not premade liquid. Just add water and stir! Made with 100% pure cane sugar, no artificial colors, flavors, or preservatives. Ships fast and light. Each resealable pouch stays fresh until you\'re ready to mix.',
  features: [
    'Dry mix — just add water & stir',
    'Made with 100% pure cane sugar',
    'No artificial colors or dyes',
    'Resealable pouch for freshness',
    'Easy-to-follow mixing instructions',
    'Veterinarian approved formula',
    'Ships fast & light — no heavy liquids',
  ],
};

// Keep legacy `products` export for checkout page compatibility
export const products = servingOptions.map((opt) => ({
  ...opt,
  id: opt.id,
  size: opt.label,
  name: `Front Porch Nectar - ${opt.label}`,
  image: opt.id === '8srv'
    ? 'https://static.readdy.ai/image/31c717393011dd03ef3cba1fd0ceabcf/e8d1ccb2976c251da973506a218a4c98.png'
    : opt.id === '32srv'
    ? 'https://static.readdy.ai/image/31c717393011dd03ef3cba1fd0ceabcf/3bf65b63b4108cf5caba13c7e53ed896.png'
    : product.image,
  description: product.description,
  features: product.features,
}));

export const reviews = [
  {
    id: 1,
    name: 'Sarah Mitchell',
    location: 'Austin, Texas',
    rating: 5,
    date: '2025-01-15',
    title: 'Hummingbirds love it!',
    text: 'I have been using this nectar for three months now and the hummingbirds absolutely love it! I have noticed more birds visiting my feeders since switching to this brand. The powder mixes easily and stays fresh in the resealable pouch.',
    avatar: 'https://public.readdy.ai/ai/img_res/9211e34ac01752b68546f62d153a163b.jpg',
    helpful: 24,
  },
  {
    id: 2,
    name: 'Michael Chen',
    location: 'Portland, Oregon',
    rating: 5,
    date: '2025-01-10',
    title: 'Best nectar on the market',
    text: 'After trying several brands, this is by far the best hummingbird nectar I have found. The ingredients are all natural, it mixes perfectly with no clumping, and my feeders stay cleaner longer. Highly recommend to any bird lover!',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20man%20smiling%20portrait%20natural%20lighting%20warm%20expression%20happy%20customer%20testimonial%20photo%20realistic%20asian&width=80&height=80&seq=avatar2&orientation=squarish',
    helpful: 18,
  },
  {
    id: 3,
    name: 'Jennifer Rodriguez',
    location: 'Tucson, Arizona',
    rating: 5,
    date: '2025-01-05',
    title: 'Perfect for migration season',
    text: 'Living in Arizona, we get tons of hummingbirds during migration. This nectar has been perfect for keeping up with demand. The 32-serving pouch lasts me the entire season and the birds seem healthier and more energetic than ever!',
    avatar: 'https://readdy.ai/api/search-image?query=friendly%20woman%20smiling%20portrait%20natural%20lighting%20warm%20expression%20happy%20customer%20testimonial%20photo%20realistic%20latina&width=80&height=80&seq=avatar3&orientation=squarish',
    helpful: 31,
  },
];
